import { LuChevronsRight } from 'react-icons/lu';
import { Link } from 'react-router-dom';
import { TRANSACTION_HISTORY } from '../../../constants/dashboard';
import { transactionHistoryColumns } from '../../../constants/tableColumns';
import { useAuthContext } from '../../../contexts/AuthProvider';
import DashboardSectionLayout from '../../../layouts/DashboardSectionLayout';
import { Client } from '../../../types/users';
import AcademiaPieChart from '../../CommonComps/Charts/AcademiaPieChart';
import AcademiaDashboardTable from '../../CommonComps/Tables/AcademiaDashboardTable';

const TransactionHistory = () => {
  // integration of context hooks here
  const { currentUser } = useAuthContext();

  const currentCredits = (currentUser as Client)?.current_credits || 0;

  // rendering transaction history section component here
  return (
    <>
      {currentUser && (
        <section className='grid grid-cols-1 xl:grid-cols-[60%_1fr] 2xl:grid-cols-[70%_1fr] gap-5'>
          <DashboardSectionLayout sectionTitle='Transaction History'>
            <AcademiaDashboardTable
              data={TRANSACTION_HISTORY}
              columns={transactionHistoryColumns}
            />

            <div className='mt-2 flex items-center justify-end'>
              <Link
                to={'/history/transaction'}
                className='flex items-center justify-center gap-1 text-base-light-blue font-medium hover:opacity-70 active:scale-95 duration-300'
              >
                <span>Show More</span> <LuChevronsRight className='size-6' />
              </Link>
            </div>
          </DashboardSectionLayout>

          <DashboardSectionLayout sectionTitle='Transaction Summary'>
            <AcademiaPieChart
              data={[
                {
                  name: 'Used Credits',
                  value:
                    (currentUser as Client)
                      .total_credits_purchased_using_dollars +
                    (currentUser as Client)
                      .total_credits_purchased_using_manual -
                    currentCredits,
                },
                {
                  name: 'Remaining Credits',
                  value: (currentUser as Client).current_credits,
                },
              ]}
              totalLabel='Total Purchased Credits'
              total={
                (currentUser as Client).total_credits_purchased_using_dollars +
                (currentUser as Client).total_credits_purchased_using_manual
              }
              colors={[
                '#FF8042',
                '#845adf', // purple
              ]}
            />
          </DashboardSectionLayout>
        </section>
      )}
    </>
  );
};

export default TransactionHistory;
